'use client'

import { motion } from 'framer-motion'
import Link from 'next/link'
import { ArrowRight, QrCode, BarChart3, Globe } from 'lucide-react'
import { useTranslations, useLocale } from 'next-intl'
import PhoneMockup from './PhoneMockup'
import GoogleSignInButton from './GoogleSignInButton'
import '../../sass/landing/Hero.scss'

const Hero = () => {
  const t = useTranslations('LandingV2.hero')
  const locale = useLocale()
  const menuUrl = locale === 'es' ? '/menu/barcraft' : '/menu/barcraft/en'

  return (
    <section className='hero'>
      <div className='hero__bg' aria-hidden='true'>
        <div className='hero__grid' />
        <div className='hero__orb hero__orb--1' />
        <div className='hero__orb hero__orb--2' />
      </div>

      <div className='hero__container'>
        <motion.div
          className='hero__text'
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        >
          <h1 className='hero__title'>
            {t.rich('title', {
              highlight: (chunks) => <span className='hero__highlight'>{chunks}</span>
            })}
          </h1>

          <p className='hero__subtitle'>{t('subtitle')}</p>

          <div className='hero__ctas'>
            <div className='hero__ctas-row'>
              <Link href='/login/signup' className='landing-v2__btn landing-v2__btn--accent landing-v2__btn--lg'>
                {t('primaryCta')} <ArrowRight size={18} />
              </Link>
              <GoogleSignInButton source='hero' variant='hero' />
            </div>
            <Link href={menuUrl} target='_blank' className='hero__demo-link'>
              {t('secondaryCta')}
            </Link>
          </div>

          {/* <div className='hero__meta'>
            <span><Check size={14} /> {t('meta1')}</span>
            <span><Check size={14} /> {t('meta3')}</span>
          </div> */}
        </motion.div>

        <motion.div
          className='hero__visual'
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
        >
          <PhoneMockup showAllergens />

          <motion.div
            className='hero__float hero__float--1'
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.7 }}
          >
            <span className='hero__float-icon' aria-hidden='true'>
              <QrCode size={16} />
            </span>
            <span className='hero__float-text'>{t('float1')}</span>
          </motion.div>
          <motion.div
            className='hero__float hero__float--2'
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.9 }}
          >
            <span className='hero__float-icon' aria-hidden='true'>
              <BarChart3 size={16} />
            </span>
            <span className='hero__float-text'>{t('float2')}</span>
          </motion.div>
          <motion.div
            className='hero__float hero__float--3'
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 1.1 }}
          >
            <span className='hero__float-icon' aria-hidden='true'>
              <Globe size={16} />
            </span>
            <span className='hero__float-text'>{t('float3')}</span>
          </motion.div>
        </motion.div>
      </div>
    </section>
  )
}

export default Hero
